import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskEmail',
  standalone: true,
})
export class MaskEmailPipe implements PipeTransform {
  transform(email: string | null | undefined): string {
    if (!email) return '';

    const [name, domain] = email.split('@');
    if (!name || !domain) return email;

    if (name.length <= 4) {
      return `${name[0]}...${name[name.length - 1]}@${domain}`;
    }

    return `${name.slice(0, 2)}...${name.slice(-2)}@${domain}`;
  }
}
